export const GetStringTotal = (label, total) => {
    let string = '';
    if (total > 1 & !label.match(/univers/)) {
        string = `${label}s`;
    } else {
        string = `${label}`;
    }
    return string;
}